import React, {Fragment, useRef, useEffect} from 'react';
import parse from 'html-react-parser';

const CookieConsent = ({ values }) => {
    const consentRef = useRef(null);
    let showConsent = true;
    const cookieText = values.text;

    useEffect(() => {
        setTimeout(() => { 
            consentRef?.current?.classList?.add("slide--up");
        }, 200);
    });

    if (document.cookie.indexOf("cookieconsent=true") >= 0) {
        showConsent = false;
    }
    
    const cookieConsentClickHandler = () => {
        consentRef.current.classList.remove("slide--up");
        consentRef.current.classList.add("slide--down");
        
        const currentDate = new Date();
        currentDate.setFullYear(currentDate.getFullYear() + 1);

        document.cookie = "cookieconsent=true;path=/;expires=" + currentDate;
    }

    return (
        <Fragment>
            {showConsent && 
                <div className="cookie-consent__container slide-animation" ref={consentRef}>
                    {parse(cookieText)}
                    <button className="button" onClick={cookieConsentClickHandler}>{values.buttonText}</button>
                </div>
            }
        </Fragment>
    );
};

export default CookieConsent;
